import Model from "~/models/_Model";

export default class RequestSync extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/courseplanner";
  }

  // Set the resource route of the model
  resource() {
    return "request-sync";
  }

  relations() {
    return {};
  }

  // Computed Attributes
}
